// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"SignUp_MainContainer__1gMgV","ModeChange":"SignUp_ModeChange__1SC96"};